'use client'
import { useEffect } from 'react'

const HideGiggsy = () => {

    useEffect(() => {
        const killChatbot = () => {
        const el = document.getElementById("dx_chatbot_fab_wrapper_id");
            if (el) {
                console.log("🔥 Removing chatbot widget");
                el.remove();
            }
        };

        killChatbot();

        const obs = new MutationObserver(killChatbot);
        obs.observe(document.body, { childList: true, subtree: true });

        return () => obs.disconnect();
    }, []);


    return (
        <></>
    )
}

export default HideGiggsy;
